import { Component } from '@angular/core';

@Component({
  selector: 'shared-expertise-loader',
  templateUrl: './expertise-loader.component.html',
  styleUrls: ['./expertise-loader.component.scss'],
})
export class ExpertiseLoaderComponent {
}
